import React from 'react';
import PropTypes from 'prop-types';
import CommissionProp from '../proptype/commissionProp';

export default function ActionsColumnCommission({
  t,
  commission,
  salesIntegration,
  isWeelodgeCommissionModel,
}) {
  const { description } = commission;

  const hasSaleModal = salesIntegration || isWeelodgeCommissionModel;
  if (!hasSaleModal && !description?.length > 0) {
    return '';
  }
  return (
    <div>
      <span className="dropdown">
        <a
          href="sections/commissions/components/ActionsColumnCommission#"
          className="btn m-btn m-btn--hover-brand m-btn--icon m-btn--icon-only m-btn--pill"
          data-toggle="dropdown"
          aria-expanded="false"
        >
          <i className="la la-ellipsis-h" />
        </a>
        {description?.length > 0 || hasSaleModal ? (
          <div className="dropdown-menu dropdown-menu-right">
            {hasSaleModal && (
              <a
                className="dropdown-item open-modal"
                data-commission={JSON.stringify(commission)}
              >
                <i className="la la-search" />
                {t('more.details')}
              </a>
            )}
            {description?.length > 0 && (
              <a
                className="dropdown-item open-modal-description"
                data-commission={JSON.stringify(commission)}
              >
                <i className="la la-eye" />
                {t('see.description')}
              </a>
            )}
          </div>
        ) : null}
      </span>
    </div>
  );
}

ActionsColumnCommission.propTypes = {
  /** Translation function */
  t: PropTypes.func.isRequired,
  commission: PropTypes.shape(CommissionProp.propType).isRequired,
  salesIntegration: PropTypes.bool.isRequired,
  isWeelodgeCommissionModel: PropTypes.bool.isRequired,
};

ActionsColumnCommission.defaultProps = {};
